import { BreakpointWidth } from '@app/enumerations';
import { createStyles, makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => {
	return createStyles({
		table_container: {
			height: '100%',
			display: 'flex',
			position: 'relative',
			flexDirection: 'column',
			margin: theme.spacing(0, 5),
		},
		table_scrollbarContainer: {
			height: '100%',
			scrollbarWidth: 'thin',
			marginBottom: theme.spacing(2),
			'&::-webkit-scrollbar': {
				width: '14px',
			},
			'&::-webkit-scrollbar-track': {
				borderRadius: '10px',
			},
			'&::-webkit-scrollbar-thumb': {
				borderRadius: '10px',
				background: theme.palette.grey[300],
				border: '4px solid rgba(0, 0, 0, 0)',
				backgroundClip: 'padding-box',
			}
		},
	});
});

export default useStyles;
